import emberData__model, { attr } from '@ember-data/model';
import type { EducationFunction } from 'common/addon/enums/education-function.enum';
import type { Gender } from 'common/addon/enums/gender.enum';
import type { JobStatus } from 'common/addon/enums/job-status.enum';
import type { Nationality } from 'common/addon/enums/nationality.enum';
import type { ProfessionalSituation } from 'common/addon/enums/professional-situation.enum';
import type { StudyLevel } from 'common/addon/enums/study-level.enum';
import type { TypeOfTeaching } from 'common/addon/enums/type-of-teaching.enum';
import type { UnemployedLength } from 'common/addon/enums/unemployed-length.enum';
import type { UserKind } from 'common/addon/enums/user-kind.enum';
import type { AddressInterface } from 'frontend/interfaces/address';

export default class BaseApplyUserModel extends emberData__model {
  @attr() declare kind?: UserKind;
  @attr('string') declare firstName?: string;
  @attr('string') declare lastName?: string;
  @attr('boolean') declare newsAgreement: boolean;
  @attr('boolean') declare termsAgreement: boolean;
  @attr('string') declare email?: string;
  @attr('string') declare phone?: string;
  @attr('string') declare registerNumber?: string;
  @attr('string') declare companyName?: string;
  @attr('string') declare companyNumber?: string;
  @attr('string') declare institution?: string;
  @attr('boolean') declare cooperationAgreement?: boolean;
  @attr() declare gender?: Gender;
  @attr() declare nationality?: Nationality;
  @attr() declare professionalSituation?: ProfessionalSituation;
  @attr() declare unemployedLength?: UnemployedLength;
  @attr() declare studyLevel?: StudyLevel;
  @attr() declare address?: AddressInterface;
  @attr('boolean') declare isBillingAddress?: boolean;
  @attr() declare billingAddress?: AddressInterface;
  @attr('boolean') declare isCommittee?: boolean;
  @attr('boolean') declare isTrainingVoucher?: boolean;
  @attr('string') declare function?: string;
  @attr() declare jobStatus?: JobStatus;
  @attr() declare educationFunction?: EducationFunction;
  @attr('string') declare faseNumber?: string;
  @attr() declare typeOfTeaching?: TypeOfTeaching;
}
